import * as R from 'ramda';
import { Prices } from '../../interfaces/productPricesTooltip.interfaces';
import { WholesalePriceSectionProps } from '../interfaces/wholesalePriceSection.interfaces';

const useWholesalePriceSection = ({ prices }: Pick<WholesalePriceSectionProps, 'prices'>) => {
  const tooltipPrices: Prices[] =
    prices?.map((price) => ({
      sizeName: price.productSizeName,
      wholesalePrice: price.wholesalePrice,
      promotionalPrice: price.promotionalPrice,
      priceComposition: price.priceComposition?.map((composition) => ({
        label: composition.label,
        price: composition.price,
      })),
    })) || [];

  const [minNetPriceToShow, maxNetPriceToShow, minGrossPriceToShow, maxGrossPriceToShow] =
    prices.reduce(
      ([minNet, maxNet, minGross, maxGross], { wholesalePrice, promotionalPrice }) => {
        const pricesToCompare = [wholesalePrice, promotionalPrice]
          .map(Number)
          .filter((p) => !isNaN(p));

        if (pricesToCompare.length === 0) {
          return [minNet, maxNet, minGross, maxGross];
        }

        const minPrice = Math.min(...pricesToCompare);
        const maxPrice = Math.max(...pricesToCompare);

        return [
          R.isNil(minNet) ? minPrice : Math.min(minNet, minPrice),
          R.isNil(maxNet) ? minPrice : Math.max(maxNet, minPrice),
          R.isNil(minGross) ? maxPrice : Math.min(minGross, maxPrice),
          R.isNil(maxGross) ? maxPrice : Math.max(maxGross, maxPrice),
        ];
      },
      [undefined, undefined, undefined, undefined] as [
        number | undefined,
        number | undefined,
        number | undefined,
        number | undefined,
      ],
    );

  return {
    tooltipPrices,
    minNetPriceToShow,
    minGrossPriceToShow,
    maxNetPriceToShow,
    maxGrossPriceToShow,
  };
};

export default useWholesalePriceSection;
